<ng-container *ngIf="unselectedSorts$ | async as unselectedSorts">
    <button
        *ngIf="unselectedSorts.length > 0 || !hideIfEmpty"
        [matMenuTriggerFor]="sortMenu"
        class="sort-options-btn"
        mat-icon-button
        matTooltip="Apply sort"
        matTooltipClass="redClass"
        matTooltipPosition="above">
        <mat-icon class="toolbar_icon_color">sort</mat-icon>
    </button>

    <mat-menu #sortMenu="matMenu" class="main_filter">
        <ng-container *ngIf="unselectedSorts.length > 0; else noAvailableSorts">
            <button
                *ngFor="let sort of unselectedSorts"
                mat-menu-item
                (click)="selectSort(sort)">
                {{ sort.name }}
            </button>
        </ng-container>
        <ng-template #noAvailableSorts>
            <span class="empty-sort-set">No sorts available</span>
        </ng-template>
    </mat-menu>
</ng-container>
